import { Error } from '../interface/upplm.common.interface';

export class QVListRequest {
    username: string;
    startDate: string;
    endDate: string;
    clientKeys: string[];
    query: string;
    queryBy: string;
    placardStatus: string[];
    offset: string;
    limit: string;
    sort: string;
    locale: string = '';
    cookie: string;
}

export class QVListResponse {
    locations: Location[];
    placardsCount: number;
    supportPhoneNumber: string;
    urlTemporary: string;
    errors?: Error[]; 
}

export class Location{
    placardId: string;
    placardStatus: string;
    lastPlacardUpdate: string;
    daysBeforePickupStart: number;
    isHung: boolean;
    pickupStartDate: string;
    companyName: string;
    activationDate: string;
    deactivationDate: string;
    reactivationDate: string;
    cancelDate: string;
    address: Address = new Address();
    clientKeys: Clients[];
    friendlyPlacardStatus: string;
}

export class Address {
    AddressLine1: string;
    AddressLine2: string;
    CityTown: string;
    StateProvince: string;
    PostalCode: string;
    countryCode: string;
}

export class Clients {
    clientKey: string;
    nickname: string;
}